import React from "react";
import Highlighter from "react-highlight-words";

const ArrowSVG = (props) => (
  <svg
    width="6"
    height="13"
    viewBox="0 0 6 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M5.9958 6.40599C5.97713 6.26155 5.92111 6.12795 5.83398 6.02324L1.05416 0.245755C0.947574 0.0995131 0.794313 0.0110507 0.630166 0.00111346C0.466014 -0.00971932 0.304978 0.0588883 0.185941 0.189785C0.0661345 0.321584 -0.000771993 0.504843 6.68401e-06 0.695315C6.68629e-06 0.886695 0.0684676 1.06815 0.189053 1.19904L4.57673 6.5L0.189053 11.801C0.0684678 11.9319 6.82017e-06 12.1133 6.82245e-06 12.3047C-0.000770897 12.4952 0.0661346 12.6784 0.185941 12.8102C0.30497 12.9411 0.465999 13.0097 0.630166 12.9989C0.794317 12.989 0.947586 12.9005 1.05416 12.7542L5.83318 6.97676C5.95921 6.8251 6.01834 6.61477 5.995 6.40622L5.9958 6.40599Z"
      fill="#0C2E40"
    />
  </svg>
);

const slugify = (text) => {
    return text
      .toString()
      .normalize("NFD") // split an accented letter in the base letter and the acent
      .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");
  };

  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;
  
      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);
  
      return <input type="checkbox" ref={resolvedRef} {...rest} />;
    }
  );

  function HighlighterGlobalWithClasses({ value, state, cell }) {
    const slug = slugify(value);
    if (state.globalFilter) {
      return (
        <span className={slug}>
          <Highlighter
            highlightClassName="highlight"
            searchWords={[state.globalFilter]}
            autoEscape={true}
            textToHighlight={value}
          />
        </span>
      );
    } else {
      return <span className={slug}>{value}</span>;
    }
  }
  

export { ArrowSVG, slugify, IndeterminateCheckbox, HighlighterGlobalWithClasses };
